import React, { useState, useEffect } from 'react';
import { toMiamiDateString } from '../utils/dateUtils';
import './WorkReportTable.css';

// Period picker for the Work Performance reports: "Show last Nw" presets, All,
// and a custom from–to. Calls onChange({ from, to }) (YYYY-MM-DD, Miami dates);
// pass a stable onChange (a state setter) — it runs whenever the period changes.

const ALL_FROM = '2000-01-01';
const addDays = (iso, n) => { const d = new Date(iso + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };

const RangeToolbar = ({ presets, initialWeeks, onChange, children, right }) => {
  const today = toMiamiDateString(new Date());
  const [mode, setMode] = useState(initialWeeks);          // number of weeks | 'all' | 'custom'
  const [from, setFrom] = useState(addDays(today, -30));
  const [to, setTo] = useState(today);

  useEffect(() => {
    if (mode === 'custom') { if (from && to && from <= to) onChange({ from, to }); return; }
    if (mode === 'all') { onChange({ from: ALL_FROM, to: today }); return; }
    onChange({ from: addDays(today, -(mode * 7) + 1), to: today });
  }, [mode, from, to, today, onChange]);

  return (
    <div className="wrt-toolbar">
      <div className="wrt-toolbar__left">
        <span className="wrt-toolbar__label">Show last</span>
        {presets.map(w => (
          <button key={w} className={`wrt-week-btn${mode === w ? ' active' : ''}`} onClick={() => setMode(w)}>{w}w</button>
        ))}
        <button className={`wrt-week-btn${mode === 'all' ? ' active' : ''}`} onClick={() => setMode('all')}>All</button>
        <button className={`wrt-week-btn${mode === 'custom' ? ' active' : ''}`} onClick={() => setMode('custom')}>Custom</button>
        {mode === 'custom' && (
          <span className="wrt-range">
            <input type="date" value={from} max={to} onChange={e => setFrom(e.target.value)} />
            <span className="wrt-range__sep">–</span>
            <input type="date" value={to} min={from} onChange={e => setTo(e.target.value)} />
          </span>
        )}
        {children}
      </div>
      {right}
    </div>
  );
};

export default RangeToolbar;
